import {jwtDecode} from "jwt-decode";

export const USER_ACCOUNTS_STORE = "user_accounts";
export const USER_ACCOUNTS_HOME_PATH = "/workspace";

export const USER_ACCOUNT_ROLES = {
    SUPER_ADMIN: "SUPER ADMIN",
    HK_CONSULTANT: "HK CONSULTANT",
    HK_REPRESENTATIVE: "HK REPRESENTATIVE",
    ADMIN: "ADMIN",
    REPRESENTATIVE: "REPRESENTATIVE",
    CUSTOMER: "CUSTOMER",
} as const;

export type UserAccountRole = typeof USER_ACCOUNT_ROLES[keyof typeof USER_ACCOUNT_ROLES];

export type AuthTokenClaims = {
    exp?: number;
    business_id?: string | number | null;
    business_type_id?: string | number | null;
    company_id?: string | number | null;
    user_id?: string | number | null;
    legacy_user_id?: string | number | null;
    auth_user_id?: string | number | null;
    user_store?: string | null;
    email?: string | null;
    job_title_id?: string | null;
    role?: string | null;
    roles?: unknown;
    is_message_input?: boolean;
    name?: string;
    picture?: string;
};

export function normalizeUserAccountRole(value: unknown): string {
    return String(value ?? "")
        .trim()
        .replace(/[_-]+/g, " ")
        .replace(/\s+/g, " ")
        .toUpperCase();
}

export function isUserAccountsSession(claims: AuthTokenClaims | null | undefined): boolean {
    const store = String(claims?.user_store ?? "").trim().toLowerCase();
    return store === USER_ACCOUNTS_STORE;
}

export function shouldUseUserAccountsExperience(
    claims: AuthTokenClaims | null | undefined
): boolean {
    return isUserAccountsSession(claims);
}

/**
 * Workspace uses the server-signed canonical account identity. Sessions issued
 * before the account migration must sign in again to obtain that identity.
 */
export function getAuthenticatedHomePath(
    claims: AuthTokenClaims | null | undefined
): string {
    return shouldUseUserAccountsExperience(claims)
        ? USER_ACCOUNTS_HOME_PATH
        : "/login";
}

export function decodeAuthTokenClaims(token: string | null | undefined): AuthTokenClaims | null {
    if (!token) return null;

    try {
        return jwtDecode<AuthTokenClaims>(token);
    } catch {
        return null;
    }
}

export function readStoredAuthTokenClaims(): AuthTokenClaims | null {
    return decodeAuthTokenClaims(localStorage.getItem("authToken"));
}
